<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('bill.set_sharing_tag') }}</div>
    <div slot="body">
      <a-form-model
        ref="form"
        class="mt-3"
        :model="form"
        :rules="rules"
        v-bind="formItemLayout">
        <a-form-model-item :label="$t('bill.project_tag_key')" prop="tag_key">
          <base-select
            resource="identity-metadatas/tag-value-pairs"
            v-model="form.tag_key"
            :params="tagKeyParams"
            :mapper="tagKeyMapper"
            remote
            :remoteFn="tagKeyRemoteFn"
            @change="tagKeyChange" />
          <!-- <base-select
            :options="[{id: 'ext:email', name: 'ext:email'}]"
            v-model="form.tag_key" /> -->
        </a-form-model-item>
        <a-form-model-item :label="$t('bill.project_tag_value_percent')" prop="tag_values">
          <div v-if="form.tag_key && !form.tag_values.length" style="color: red">{{ $t('common.notData') }}</div>
          <div v-else-if="!form.tag_key" style="color:red">{{ $t('common.tips.select', [$t('bill.project_tag_key')]) }}</div>
          <a-row :gutter="8" v-for="(item, index) in form.tag_values" :key="index">
            <a-col :span="16">
              <!-- <a-select v-model="item.tag_value">
                <a-select-option v-for="(item, index) in tagValueOpts" :key="index" :value="item.value">{{ item.label }}</a-select-option>
              </a-select> -->
              <a-input v-model="item.tag_value" disabled />
            </a-col>
            <a-col :span="6">
              <a-input-number class="w-100" v-model="item.percent" :max="100" :min="0" @change="percentChange" />
            </a-col>
            <a-col :span="2">%</a-col>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'SharingSetTagDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const { tag_key = '', tag_values = [] } = this.params.param
    return {
      loading: false,
      form: {
        tag_key,
        tag_values,
      },
      rules: {
        tag_key: [{ required: true, message: this.$t('common.tips.select', [this.$t('bill.project_tag_key')]) }],
        tag_values: [{
          required: true,
          validator: (rule, value, callback) => {
            let rate = 0
            value.map(item => {
              rate += item.percent
            })
            if (rate !== 100) {
              callback(new Error(this.$t('bill.rate_need_100')))
            }
            callback()
          },
        }],
      },
      formItemLayout: {
        wrapperCol: {
          span: 19,
        },
        labelCol: {
          span: 5,
        },
      },
      tagValueOpts: [],
    }
  },
  computed: {
    tagKeyParams () {
      return {
        limit: 20,
        key_only: true,
        scope: this.$store.getters.scope,
        resources: 'project',
      }
    },
  },
  created () {
    this.$tM = new this.$Manager('identity-metadatas/tag-value-pairs')
    if (!this.params.param.tag_key) {
      this.form.tag_values = []
    }
  },
  methods: {
    tagKeyRemoteFn (query) {
      return {
        key_like: query,
      }
    },
    tagKeyMapper (data) {
      return data.map(item => {
        return {
          id: item.key,
          name: item.key.replace('user:', '').replace('ext:', ''),
        }
      })
    },
    tagKeyChange (value) {
      this.$tM.list({
        params: {
          key: value,
          scope: this.$store.getters.scope,
          resources: 'project',
        },
      }).then(res => {
        const { data = [] } = res.data
        this.form.tag_values = data.map(item => {
          return {
            tag_value: item.value,
            percent: 0,
          }
        })
      })
    },
    percentChange () {
      this.$refs.form.validateField('tag_values')
    },
    // fetchTags () {
    //   try {
    //     this.loading = true
    //     await this.$pM.list({
    //       params: {
    //         limit: 0,
    //         scope: this.$store.getters.scope,
    //         offset: 0,

    //       }
    //     })
    //   } catch (err) {
    //     this.loading = false
    //     throw error
    //   }
    // },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid, err) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(err)
          }
        })
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const validate = await this.validateForm()
        if (!validate) return
        this.params.update(this.form)
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
